<template>
  <div class="product-details-container">
    <mf-card-container
      v-model="search"
      title="Detalhes dos produtos"
      description="Essa parte é essencial para que você possa criar mensagens personalizadas para cada um dos seus consumidores, usando o produto e o preço como variáveis. Se você pretende utilizar o canal SMS, recomendamos remover acentos e outros caracteres especiais, para reduzir os custos com esse disparo."
      use-search
      placeholder="Buscar produto"
    >
      <div class="card-container-content">
        <tabs-selection
          ref="tabsSelection"
          :tab.sync="tab"
          :initially-products="initiallyProducts"
          :disabled="disabled"
          :search="search"
          :tabs-validations="tabsValidations"
        />
      </div>
    </mf-card-container>
  </div>
</template>

<script>
import { mariaCampaign } from '../../../mixins/maria-campaign'
import TabsSelection from './TabsSelection.vue'

export default {
  name: 'ProductDetails',
  components: { TabsSelection },
  mixins: [mariaCampaign],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    initiallyProducts: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    tab: 0,
    search: '',
    tabsValidations: [],
  }),
  computed: {},
  methods: {
    validateStepTwoFormData() {
      const tabsSelection = this.$refs.tabsSelection

      const refs = Object.keys(tabsSelection.$refs)
        .filter((key) => key.startsWith('productsTable_'))
        .map((key) => tabsSelection.$refs[key][0])
        .filter((el) => el)

      const results = refs.map((table) => table.validateProductsData())

      const allValid = results.every((isValid) => isValid)
      this.tabsValidations = results

      if (allValid) {
      } else {
        this.$snackbar({ message: 'Verifique todos os campos.', snackbarColor: 'error' })
      }

      return allValid
    },
  },
}
</script>
